import { atom } from 'jotai';

export const availableDomainAtom = atom<string>('');
export const domainSuggestionsAtom = atom<string[]>([]);

export const resetDomainDataAtom = atom(null, (get, set) => {
  set(availableDomainAtom, '');
  set(domainSuggestionsAtom, []);
});
